import React from "react";
import { Container } from "react-bootstrap";
import  { Swiper, SwiperSlide } from "swiper/react";

// import brandImage from "@/images/client-logo.png";
import Img from "./img";
import { OurClientsData } from "@/data";
import SwiperCore, { Autoplay } from "swiper";

SwiperCore.use([Autoplay]);


const SponsorOne = ({ extraClass }) => {
  const { title, clients } = OurClientsData;

  const sponsorCarouselOptions = {
    spaceBetween: 100,
    slidesPerView: 4,
    autoplay: { delay: 2000 },
    breakpoints: {
      0: {
        spaceBetween: 30,
        slidesPerView: 2,
      },
      375: {
        spaceBetween: 30,
        slidesPerView: 2,
      },
      575: {
        spaceBetween: 30,
        slidesPerView: 3,
      },
      767: {
        spaceBetween: 50,
        slidesPerView: 4,
      },
      991: {
        spaceBetween: 50,
        slidesPerView: 4,
      },
      1199: {
        spaceBetween: 100,
        slidesPerView: 4,
      },
    },
  };

  return (
    <div
      className={`clients_logo_area text-center section_padding  ${extraClass}`}
    >
      <div className="hero-section-title text-center">
        <h1>{title}</h1>
      </div>
      <Container>
        <Swiper {...sponsorCarouselOptions} className="clients_logo ">
          <div className="swiper-wrapper">
            {clients.map((client, index) => (
              <SwiperSlide key={index}>
                <Img src={client.image} alt={`Client ${index + 1}`} />
              </SwiperSlide>
            ))}
          </div>
        </Swiper>
      </Container>
    </div>
  );
};

export default SponsorOne;
